export class RiderDetails {

    refNo: number;
    firstName: string;
    lastName: string;
    mobileNo: string;
    email: string;
    dob: string;
    education: string;
    vehicleType: string;
    vehicleNo: string;
    vehicleName: string;
    riderDlNo: string;
    aadhaarNo: string;
    riderSelfiePath: string;
    fromLocationCode: number;
    activeStatus: boolean=false;
    isVerified: boolean=false;
    reason: string;
    aadhaarImagePath: string;
    aadhaarBackImagePath: string;
    dlImagePath: string;

    vehicleRegNo: string;
    upiId: string;
    accountNo: string;
    ifscCode: string;
}
